// import React, { useState, useEffect } from 'react';
// import { Link } from "react-router-dom";
// import { useLocation } from 'react-router-dom';
// import Usernav from "../usernav/usernav";
// import "./userorderdetails.css";

// const Userorderdetails = () => {
//     const [activeSection, setActiveSection] = useState(1);
//     const [orderDetails, setOrderDetails] = useState(null);
//     const [error, setError] = useState(null);
//     const location = useLocation();
//     const passedorderId = location.state?.orderId || null;

//     const toggleSection = (sectionNumber) => {
//         setActiveSection(sectionNumber);
//     };

//     useEffect(() => {
//         if (passedorderId) {
//             const fetchOrderDetails = async () => {
//                 try {
//                     const response = await fetch(`/api/order/${passedorderId}`);
//                     const data = await response.json();
//                     setOrderDetails(data);
//                 } catch (err) {
//                     setError(err.message);
//                     console.error("Error fetching order details:", err);
//                 }
//             };
            
//             fetchOrderDetails();
//         }
//     }, [passedorderId]);

//     if (!orderDetails) {
//         return <div>Loading...</div>;
//     }

//     if (error) {
//         return <div>Error: {error}</div>;
//     }

//     return (
//         <>
//             <div className="breadcrumb-wrap bg-f br-2">
//                 <div className="container">
//                     <div className="breadcrumb-title">
//                         <h2>My Orders</h2>
//                         <ul className="breadcrumb-menu list-style">
//                             <li><Link to="#">Home</Link></li>
//                             <li>My Orders</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>
//             <div className='containerorder'>
//             <div className='row'>
//                 <div className='col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2'>
//                     <Usernav />
//                 </div>
//                 <div className='col-xl-7 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1'>
//                     <div className='orderdetailscon'>
//                         <div className='orderdetailsconfirst'>
//                             <div className='d-flex'>
//                                 {orderDetails.products && orderDetails.products.map((product, index) => (
//                                     <img 
//                                         key={index}
//                                         src={`${product.image}`}
//                                         style={{ height: "10vh", marginRight: "10px" }} 
//                                         alt={`Product ${index + 1}`} 
//                                     />
//                                 ))}
//                                 <div style={{ marginLeft: "2%" }}>
//                                 <h4>Order #{orderDetails.orderId}</h4>
//                                     <div className='itemstatus'>
//                                         {orderDetails.deliveryStatus || "In Progress"}
//                                     </div>
                                    
//                                 </div>
//                             </div>
//                             <hr />
//                             <div>
//                                 <div className='itemfirstpart'>
//                                     <div className='itemfirstpartdata'>
//                                         <h6>Item</h6>
//                                         <p>{orderDetails.products?.[0]?.name || "Product Name"}</p>
//                                     </div>
//                                     <div className='itemfirstpartdata'>
//                                         <h6>Courier</h6>
//                                         <p>FedEx World Service Center</p>
//                                     </div>
//                                 </div>
//                                 <div className='itemsecondpart'>
//                                     <div className='itemsecondpartdata'>
//                                         <h6>Start Time</h6>
//                                         <p>{new Date(orderDetails.orderDate).toLocaleString()}</p>
//                                     </div>
//                                     <div className='itemsecondpartdata'>
//                                         <h6>Address</h6>
//                                         <p>{orderDetails.customerDetails?.shippingAddress?.address || "Address not available"}</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div>
//                             <div className="order-slider">
//                                 <div className="buttons">
//                                     <button onClick={() => toggleSection(1)}>Order History</button>
//                                     <button onClick={() => toggleSection(2)}>Item Details</button>
//                                     <button onClick={() => toggleSection(3)}>Courier</button>
//                                     <button onClick={() => toggleSection(4)}>Receiver</button>
//                                 </div>
//                                 <div className="datacontainer">
//                                     <div className={`section ${activeSection === 1 ? 'active' : ''}`}>
//                                         {/* Order History Content */}
//                                     </div>
//                                     <div className={`section ${activeSection === 2 ? 'active' : ''}`}>
//                                         <div className='itemdetails'>
//                                             {orderDetails.products && orderDetails.products.map((product, index) => (
//                                                 <div key={index} className='d-flex mb-3'>
//                                                     <img 
//                                                         src={`${product.image}`}
//                                                         style={{ height: "10vh" }} 
//                                                         alt={`Product ${index + 1}`} 
//                                                     />
//                                                     <div className='itemsdetiles'>
//                                                         <h5>{product.name}</h5>
//                                                         <h6>Price: Rs.{product.price}</h6>
//                                                         <h6>Quantity: {product.size}</h6>
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                             {/* <div className='itemdetailsdata'>
//                                                 <h6>Total Price</h6>
//                                                 <h6>Rs.{orderDetails.paymentDetails?.totalAmount}</h6>
//                                             </div>
//                                             <hr />
//                                             <div className='itemdetailsdata'>
//                                                 <h6>Total Discounts</h6>
//                                                 <h6>Rs. 0</h6>
//                                             </div>
//                                             <hr /> */}
//                                             <div className='itemdetailsdata'>
//                                                 <h6>Order Total</h6>
//                                                 <h6>Rs. {orderDetails.paymentDetails?.totalAmount}</h6>
//                                             </div>
//                                             <hr />
//                                         </div>
//                                     </div>
//                                     <div className={`section ${activeSection === 3 ? 'active' : ''}`}>
//                                         <div>
//                                             <p style={{ textAlign: "justify" }}>
//                                                 Our courier service is dedicated to providing fast, reliable, and secure delivery solutions tailored to meet your needs. Whether you're sending documents, parcels, or larger shipments, our team ensures that your items are handled with the utmost care and delivered on time. With a commitment to customer satisfaction, real-time tracking, and a wide network of routes, we make it easy for you to send and receive packages both locally and internationally. Choose our service for a seamless and efficient delivery experience.
//                                             </p>
//                                         </div>
//                                     </div>
//                                     <div className={`section ${activeSection === 4 ? 'active' : ''}`}>
//                                         <div className='Receiverdetiles'>
//                                             <span style={{ color: "green" }}>Thank you! Your order has been received</span>
//                                             <p>Order Number: #{orderDetails.orderId}</p>
//                                             <p>Date: {new Date(orderDetails.orderDate).toLocaleString()}</p>
//                                             <p>Total: Rs. {orderDetails.paymentDetails?.totalAmount}</p>
//                                             <p>Payment Status: {orderDetails.paymentDetails?.status === 'completed' ? 'Paid' : 'Pending'}</p>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div></div>
//         </>
//     );
// };

// export default Userorderdetails;


import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import Usernav from "../usernav/usernav";
import "./userorderdetails.css";
import OrderTracking from './orderTracking';

const Userorderdetails = () => {
    const [activeSection, setActiveSection] = useState(1);
    const [orderDetails, setOrderDetails] = useState(null);
    const [trackingData, setTrackingData] = useState(null);
    const [error, setError] = useState(null);
    const location = useLocation();
    const passedorderId = location.state?.orderId || null;

    const toggleSection = (sectionNumber) => {
        setActiveSection(sectionNumber);
    };

    useEffect(() => {
        if (passedorderId) {
            const fetchOrderDetails = async () => {
                try {
                    const response = await fetch(`/api/order/${passedorderId}`);
                    const data = await response.json();
                    setOrderDetails(data);

                    // Fetch tracking data if AWB code is available
                    if (data.ShipmentId) {
                        fetchTrackingData(data.ShipmentId);
                    }
                } catch (err) {
                    setError(err.message);
                    console.error("Error fetching order details:", err);
                }
            };
            
            fetchOrderDetails();
        }
    }, [passedorderId]);

    const fetchTrackingData = async (awbCode) => {
        try {
            const response = await fetch(`/api/tracking/${awbCode}`); // Replace with Shiprocket API
            const data = await response.json();
            setTrackingData(data.tracking_data);
        } catch (err) {
            console.error("Error fetching tracking data:", err);
        }
    };
console.log(trackingData);
    if (!orderDetails) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <>
            <div className="breadcrumb-wrap bg-f br-2">
                <div className="container">
                    <div className="breadcrumb-title">
                        <h2>My Orders</h2>
                        <ul className="breadcrumb-menu list-style">
                            <li><Link to="/">Home</Link></li>
                            <li>My Orders</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='containerorder'>
            <div className='row'>
                <div className='col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2'>
                    <Usernav />
                </div>
                <div className='col-xl-7 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1'>
                    <div className='orderdetailscon'>
                        <div className='orderdetailsconfirst'>
                            <div className='orderdetailsconfirstdata'>
                                {orderDetails.products && orderDetails.products.map((product, index) => (
                                    <img 
                                        key={index}
                                        src={`${product.image}`}
                                        style={{ height: "20vh", marginRight: "10px" }} 
                                        alt={`Product ${index + 1}`} 
                                    />
                                ))}
                                <div style={{ marginLeft: "2%" }}>
                                    <h4>Order #{orderDetails.orderId}</h4>
                                    <div className='itemstatus'>
                                        {orderDetails.deliveryStatus || "In Progress"}
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div>
                            <div className="order-slider">
                                <div className="buttons">
                                    <button onClick={() => toggleSection(1)}>Order History</button>
                                    <button onClick={() => toggleSection(2)}>Item Details</button>
                                    <button onClick={() => toggleSection(3)}>Courier</button>
                                    <button onClick={() => toggleSection(4)}>Receiver</button>
                                </div>
                                <div className="datacontainer">
                                    {/* Order History Section */}
                                    <div className={`section ${activeSection === 1 ? 'active' : ''}`}>
                                        <h4>Shipment Tracking</h4>
                                        {trackingData ? (
                                            <>
                                            <OrderTracking status={trackingData.shipment_track[0]?.current_status} trackingData={trackingData} />
                                                <p><strong>AWB Code:</strong> {trackingData.shipment_track[0]?.awb_code}</p>
                                               
                                                <p><strong>Courier:</strong> {trackingData.shipment_track[0]?.courier_name}</p>
                                                <p><strong>Current Status:</strong> {trackingData.shipment_track[0]?.current_status}</p>
                                                <p><strong>Origin:</strong> {trackingData.shipment_track[0]?.origin}</p>
                                                <p><strong>Destination:</strong> {trackingData.shipment_track[0]?.destination}</p>
                                                <hr />
                                                <h5>Tracking Updates</h5>
                                                <ul className="tracking-timeline">
                                                    {/* {trackingData.shipment_track_activities.map((activity, index) => (
                                                        <li key={index}>
                                                            <strong>{new Date(activity.date).toLocaleString()}</strong> - {activity.activity} ({activity.location})
                                                        </li>
                                                    ))} */}
                                                    {trackingData.shipment_track_activities > 0 ? (
                                                        trackingData.shipment_track_activities.map((activity, index) => (
                                                            <li key={index}>
                                                                <strong>{new Date(activity.date).toLocaleString()}</strong> - {activity.activity} ({activity.location})
                                                            </li>   
                                                            ))
                                                        ) : (
                                                            <p>Loading tracking details...</p>
                                                        )}
                                                </ul>
                                                <a href={trackingData.track_url} target="_blank" rel="noopener noreferrer">
                                                    Track on Shiprocket
                                                </a>
                                            </>
                                        ) : (
                                            <p>Loading tracking details...</p>
                                        )}
                                    </div>

                                    {/* Item Details Section */}
                                    <div className={`section ${activeSection === 2 ? 'active' : ''}`}>
                                        <div className='itemdetails'>
                                            {orderDetails.products && orderDetails.products.map((product, index) => (
                                                <div key={index} className='d-flex mb-3'>
                                                    <img 
                                                        src={`${product.image}`}
                                                        style={{ height: "10vh" }} 
                                                        alt={`Product ${index + 1}`} 
                                                    />
                                                    <div className='itemsdetiles'>
                                                        <h5>{product.name}</h5>
                                                        <h6>Price: Rs.{product.price}</h6>
                                                        <h6>Quantity: {product.size}</h6>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className='itemdetailsdata'>
                                                <h6>Order Total</h6>
                                                <h6>Rs. {orderDetails.paymentDetails?.totalAmount ? orderDetails.paymentDetails.totalAmount.toFixed(2) : "0.00"}</h6>
                                            </div>
                                            <hr />
                                        </div>
                                    </div>

                                    {/* Courier Section */}
                                    <div className={`section ${activeSection === 3 ? 'active' : ''}`}>
                                        <p style={{ textAlign: "justify" }}>
                                            Our courier service is dedicated to providing fast, reliable, and secure delivery solutions tailored to meet your needs...
                                        </p>
                                    </div>

                                    {/* Receiver Section */}
                                    <div className={`section ${activeSection === 4 ? 'active' : ''}`}>
                                        <div className='Receiverdetiles'>
                                            <span style={{ color: "green" }}>Thank you! Your order has been received</span>
                                            <p>Order Number: #{orderDetails.orderId}</p>
                                            <p>Date: {new Date(orderDetails.orderDate).toLocaleString()}</p>
                                            <p>Total: Rs. {orderDetails.paymentDetails?.totalAmount}</p>
                                            <p>Payment Status: {orderDetails.paymentDetails?.status === 'completed' ? 'Paid' : 'Pending'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></div>
        </>
    );
};

export default Userorderdetails;


// import React, { useState } from 'react';
// import { Link } from "react-router-dom";
// import Usernav from "../usernav/usernav";
// import OrderTracking from './orderTracking';
// import "./userorderdetails.css";

// const Userorderdetails = () => {
//     const [activeSection, setActiveSection] = useState(1);

//     // Static order details for testing
//     const orderDetails = {
//         orderId: "237157589",
//         trackingNumber: "141123221084922",
//         deliveryStatus: "Delivered",
//         products: [
//             {
//                 name: "Test Product",
//                 image: "/images/product1.jpg",
//                 price: "1000",
//                 size: "1",
//             }
//         ],
//         paymentDetails: {
//             totalAmount: "1000",
//             status: "completed"
//         },
//         orderDate: "2022-07-18T20:28:00Z",
//     };

//     // Static tracking data for testing
//     const trackingData = {
//         "tracking_data": {
//             "track_status": 1,
//             "shipment_status": 7,
//             "shipment_track": [
//                 {
//                     "awb_code": "141123221084922",
//                     "courier_name": "Xpressbees Surface",
//                     "current_status": "Delivered",
//                     "origin": "Banglore",
//                     "destination": "Chittoor",
//                 }
//             ],
//             "shipment_track_activities": [
//                 {
//                     "date": "2022-07-19 11:37:00",
//                     "activity": "Delivered",
//                     "location": "Madanapalli, ANDHRA PRADESH",
//                 },
//                 {
//                     "date": "2022-07-19 08:57:00",
//                     "activity": "Out for Delivery",
//                     "location": "Madanapalli, ANDHRA PRADESH",
//                 },
//                 {
//                     "date": "2022-07-19 07:33:00",
//                     "activity": "Reached at Destination",
//                     "location": "Madanapalli, ANDHRA PRADESH",
//                 }
//             ],
//             "track_url": "https://shiprocket.co//tracking/141123221084922"
//         }
//     };

//     return (
//         <>
//             <div className="breadcrumb-wrap bg-f br-2">
//                 <div className="container">
//                     <div className="breadcrumb-title">
//                         <h2>My Orders</h2>
//                         <ul className="breadcrumb-menu list-style">
//                             <li><Link to="#">Home</Link></li>
//                             <li>My Orders</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>
//             <div className='containerorder'>
//                 <div className='row'>
//                     <div className='col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2'>
//                         <Usernav />
//                     </div>
//                     <div className='col-xl-7 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1'>
//                         <div className='orderdetailscon'>
//                             <div className='orderdetailsconfirst'>
//                                 <h4>Order #{orderDetails.orderId}</h4>
//                                 <div className='itemstatus'>
//                                     {orderDetails.deliveryStatus || "In Progress"}
//                                 </div>
//                                 <hr />
//                             </div>
//                             <div className="order-slider">
//                                 <div className="buttons">
//                                     <button onClick={() => setActiveSection(1)}>Order History</button>
//                                     <button onClick={() => setActiveSection(2)}>Item Details</button>
//                                     <button onClick={() => setActiveSection(3)}>Courier</button>
//                                 </div>
//                                 <div className="datacontainer">
//                                     {/* Order History Section */}
//                                     <OrderTracking status="SHIPPED" trackingData={trackingData.tracking_data} />
//                                     <div className={`section ${activeSection === 1 ? 'active' : ''}`}>
//                                         <h4>Shipment Tracking</h4>
                                        
//                                         {trackingData ? (
//                                             <>
//                                                 <p><strong>AWB Code:</strong> {trackingData.tracking_data.shipment_track[0]?.awb_code}</p>
//                                                 <p><strong>Courier:</strong> {trackingData.tracking_data.shipment_track[0]?.courier_name}</p>
//                                                 <p><strong>Current Status:</strong> {trackingData.tracking_data.shipment_track[0]?.current_status}</p>
//                                                 <p><strong>Origin:</strong> {trackingData.tracking_data.shipment_track[0]?.origin}</p>
//                                                 <p><strong>Destination:</strong> {trackingData.tracking_data.shipment_track[0]?.destination}</p>
//                                                 <hr />
//                                                 <h5>Tracking Updates</h5>
//                                                 <ul className="tracking-timeline">
//                                                     {trackingData.tracking_data.shipment_track_activities.map((activity, index) => (
//                                                         <li key={index}>
//                                                             <strong>{new Date(activity.date).toLocaleString()}</strong> - {activity.activity} ({activity.location})
//                                                         </li>
//                                                     ))}
//                                                 </ul>
//                                                 <a href={trackingData.tracking_data.track_url} target="_blank" rel="noopener noreferrer">
//                                                     Track on Shiprocket
//                                                 </a>
//                                             </>
//                                         ) : (
//                                             <p>Loading tracking details...</p>
//                                         )}
//                                     </div>

//                                     {/* Item Details Section */}
//                                     <div className={`section ${activeSection === 2 ? 'active' : ''}`}>
//                                         <h5>Item Details</h5>
//                                         <p><strong>Product:</strong> {orderDetails.products[0].name}</p>
//                                         <p><strong>Price:</strong> Rs.{orderDetails.products[0].price}</p>
//                                         <p><strong>Quantity:</strong> {orderDetails.products[0].size}</p>
//                                     </div>

//                                     {/* Courier Section */}
//                                     <div className={`section ${activeSection === 3 ? 'active' : ''}`}>
//                                         <p>Our courier service is fast and reliable...</p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Userorderdetails;
